import { Container, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import QuestionExpertCard from '../Cards/QuestionExpertCard';
import ImageMentoria1 from '../../Assets/Arena/mentoria1.png';
import ImageMentoria2 from '../../Assets/Arena/mentoria2.png';

const questions = [
	{
		image: ImageMentoria1,
		title: 'Estações individuais e mentorias com instrutores revalidados',
		description:
			'Instrutores revalidados, que entendem do assunto e vão treinar a estação e o checklist com você, dando orientações personalizadas e individuais.',
	},
	{
		image: ImageMentoria2,
		title: 'Mentorias em grupo semanal ',
		description:
			'Mentorias em grupo, para auxiliar no gerenciamento das emoções e na preparação em cada etapa da jornada até a prova prática.',
	},
];

export default function QuestionsExperts() {
	const classes = useStyles();

	return (
		<Container
			fixed
			maxWidth="xl"
			disableGutters={true}
			className={'revalida'}
		>
			<Grid
				container
				className="section"
				style={{
					margin: '0 auto',
					paddingTop: '40px',
				}}
			>
				<Grid container>
					<Grid
						container
						className="section"
						style={{ margin: '0 auto' }}
					>
						<Grid
							container
							item
							className={classes.container}
						>
							<Grid
								item
								xs={12}
								container
								style={{ marginBottom: 16 }}
							>
								<Typography
									className={classes.title}
									fontFamily={'Manrope'}
								>
									Mentoria e prática de estações com instrutores revalidados
								</Typography>
							</Grid>

							<Grid
								xs={12}
								container
								item
								spacing={4}
								justifyContent={'center'}
							>
								{questions.map((item, index) => (
									<Grid
                                        key={index}
										item
										container
										xs={12}
										sm={12}
										md={6}
									>
										<QuestionExpertCard {...item} />
									</Grid>
								))}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Container>
	);
}

const useStyles = makeStyles((theme) => ({
    container: {
        margin: '40px 0 64px !important',
        [theme.breakpoints.down('md')]: {
            margin: '24px 0 !important',
		},
    },
    title: {
        color: '#FCFCFC',
		fontSize: '2.5rem !important',
		fontWeight: 'bold !important',
		[theme.breakpoints.down('md')]: {
			lineHeight: 'unset !important',
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: '1.6rem !important',
			lineHeight: 'unset !important',
		},
	},
}));
